<div class="container py-5 text-center">

  @if(setSignatureResponse.success) {
    <div class="alert alert-success alert-dismissible fade show text-start" role="alert" style="z-index: 6" >
      {{languageService.languageConfig?.set_sign_success_msg}}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  }

    @if(setSignatureResponse.error) {
    <div class="alert alert-danger alert-dismissible fade show text-start" role="alert" style="z-index: 6" >
      {{languageService.languageConfig?.set_sign_failure_msg}}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  }
  <!-- <img src="../../assets/Set_Sign_Image.png" width="600" height="350" /> -->
  <h1>{{languageService.languageConfig?.how_to_set_sign}}</h1>

  <div class="content">
    <div class="instructions">
      <ul [innerHTML]="languageService.languageConfig?.set_signature_instructions">
        
      </ul>
    </div>

    <div class="screenshots">
      <div class="screenshot green-box">
        <img [src]="languageService.languageConfig?.quick_setting_img" alt="See all settings" />
      </div>
      <div class="screenshot blue-box">
        <img [src]="languageService.languageConfig?.insert_sign_img" alt="Signature defaults" />
      </div>
    </div>
  </div>

</div>